/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostOptimizationCloudAccountTypeRequest {
    getFixupPrototypeFunction() { return CostOptimizationCloudAccountTypeRequest.fixupPrototype; }

    static newInstance(model: Partial<CostOptimizationCloudAccountTypeRequest>): CostOptimizationCloudAccountTypeRequest {
        let obj = Object.assign(new CostOptimizationCloudAccountTypeRequest(), model);
        CostOptimizationCloudAccountTypeRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostOptimizationCloudAccountTypeRequest>): CostOptimizationCloudAccountTypeRequest {
        if (!model) return null;
        return CostOptimizationCloudAccountTypeRequest.newInstance(<CostOptimizationCloudAccountTypeRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostOptimizationCloudAccountTypeRequest) {
        if (!obj) return;

        models.CostOptimizationCloudAccountTypeRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostOptimizationCloudAccountTypeRequest): boolean {
        Object.setPrototypeOf(obj, CostOptimizationCloudAccountTypeRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * currency type
     */
    currency: string;

    /**
     * Cloud account type
     */
    cloud_account_type: Array<string>;

    /**
     * Cloud account id
     */
    cloud_account_id: Array<string>;

}
